import React from 'react';

const Account = () => {
    return (
        <div>
            This is Account
        </div>
    );
};

export default Account;